import { render } from "./AddEditTargetProductGroup.vue?vue&type=template&id=29363695"
import script from "./AddEditTargetProductGroup.vue?vue&type=script&lang=js"
export * from "./AddEditTargetProductGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__